/**
 * 筛选表单的渐进增强。
 *
 * 表单本体是普通 GET,没有这段脚本一样能筛、能排序、能分享 URL。
 * 这里只加三件事:
 *   1. 窄屏把筛选面板收进抽屉(按钮平时是 hidden,由脚本放出来)
 *   2. 换排序即提交 —— 桌面端没人想再点一次「Apply」
 *   3. 桌面端勾选筛选也即提交,并把「Apply」收起来
 *   4. Esc 关抽屉,并把焦点还给触发按钮
 *
 * 不做的事:不接管提交、不在前端过滤商品、不整目录加载到浏览器里。
 * 分页和结果数必须由服务端说了算,否则 canonical 和爬虫都会乱。
 */

export const MOBILE_QUERY = '(max-width: 767px)';

export function createCollectionFilters({ document, matchMedia }) {
  function setup(form) {
    const toggle = form.querySelector('[data-trips-filters-toggle]');
    const panel = form.querySelector('[data-trips-filters-panel]');
    const sort = form.querySelector('[data-trips-filters-sort]');
    if (!panel) return null;

    const media = matchMedia ? matchMedia(MOBILE_QUERY) : null;

    const setOpen = (open) => {
      if (!toggle) return;
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      form.classList.toggle('is-open', open);
    };

    const applyLayout = () => {
      const narrow = Boolean(media && media.matches);
      if (toggle) toggle.hidden = !narrow;
      // 宽屏永远展开:抽屉只对窄屏有意义
      if (!narrow) setOpen(false);
      form.classList.toggle('is-collapsible', narrow);
      // 即时提交只在宽屏开。窄屏抽屉里通常是勾几个再一起应用,
      // 每点一次就跳走会把人赶出抽屉。
      form.classList.toggle('is-live', !narrow);
    };

    if (toggle) {
      toggle.addEventListener('click', () => {
        setOpen(toggle.getAttribute('aria-expanded') !== 'true');
      });
    }

    form.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || !toggle) return;
      if (toggle.getAttribute('aria-expanded') !== 'true') return;
      event.preventDefault();
      setOpen(false);
      if (toggle.focus) toggle.focus();
    });

    const submit = () => {
      if (form.requestSubmit) form.requestSubmit();
      else form.submit();
    };

    if (sort) {
      // 换排序即提交。表单里同时带着筛选项,所以条件不会丢。
      sort.addEventListener('change', submit);
    }

    // 勾选筛选也即提交 —— 但只在宽屏(is-live 由 applyLayout 决定)。
    // 监听挂在 panel 上而不是每个 input 上:分面是 Shopify 给的,
    // 数量和取值都会变,逐个绑定迟早漏掉新出现的那一个。
    panel.addEventListener('change', (event) => {
      const target = event.target;
      if (!target || target.type !== 'checkbox') return;
      if (!form.classList.contains('is-live')) return;
      submit();
    });

    if (media && media.addEventListener) media.addEventListener('change', applyLayout);
    applyLayout();

    return { applyLayout, setOpen };
  }

  return {
    install() {
      return Array.from(document.querySelectorAll('[data-trips-filters]'))
        .map(setup)
        .filter(Boolean);
    },
  };
}

if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  createCollectionFilters({
    document,
    matchMedia: window.matchMedia.bind(window),
  }).install();
}
